export enum ReviewFormStep {
  Start = "start",
  Form = "form",
  Finish = "finish"
}
